
import styled from "styled-components"
import { useState } from "react"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getNakliyeKaynakData, updateNakliyeKaynakData } from "../../features/nakliyeIndex/nakliyeIndexSlice"
import { useSelector } from "react-redux"
import InputText from "../shared/input/new/InputText"
import Btn from "../shared/button/Btn"

const Container = styled.div`
    width: auto;
    color: ${({theme}) => theme.mainTextColor};

    .top-container{
        width: 100%;
        padding-bottom: 5px;
        
        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
        }
    }

    .input-list{
        margin:  30px 0;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`
const NakliyeKaynakVerileri = () => {

    const {nakliyeKaynakData} = useSelector(state => state.nakliyeIndex)

    const [kaynakData, setKaynakData ] = useState(null)

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(getNakliyeKaynakData())
    },[])

    useEffect(()=> {
        setKaynakData(nakliyeKaynakData)
    },[nakliyeKaynakData])


    const handleChange = (e) => {
        setKaynakData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value.replace(/[^0-9]/g, '')}))
    }

    const handleClick = () => {
        dispatch(updateNakliyeKaynakData(kaynakData))
    }

  return (
    <Container>

        <div className="top-container">
            <h4>Nakliye Fiyatı Hesaplama Kaynak Verileri</h4>
        </div>

        <div className="input-list">
            <InputText data={kaynakData?.yavasGiderAzaltmaOran} setData={handleChange} labelText={"Yavaş Gider Azaltma Oranı (%)"} inputWidth={"320px"} name={"yavasGiderAzaltmaOran"}/>
            <InputText data={kaynakData?.hizliGiderArtırmaOran} setData={handleChange} labelText={"Hızlı Gider Artırma Oranı (%)"} inputWidth={"320px"} name={"hizliGiderArtırmaOran"}/>
            <InputText data={kaynakData?.tabanKm} setData={handleChange} labelText={"Taban Km (Bu mesafenin altı tam gün alınır)"} inputWidth={"320px"} name={"tabanKm"}/>
            <Btn width={"320px"} color="#fff" handleClick={handleClick} bgColor="#E85446">Güncelle</Btn>
        </div>

    </Container>
  )
}

export default NakliyeKaynakVerileri